/** Сверка сборок показанных ответов «WB: регионы»: meta, регионы, офферы, карточка кэшируются
 *  отдельно и могут прийти из разных сборок (`state.built_at`). Не совпало — сброс всего кэша
 *  раздела (`["wb-regions"]`) и перезапрос; плашка — `BuildBanners`. */
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

import type { WbRegionsState } from "@/api/wbRegions";
import { WB_QUERY_ROOT } from "./queries";

export type MaybeState = WbRegionsState | null | undefined;

export function present(states: MaybeState[]): WbRegionsState[] {
  return states.filter((s): s is WbRegionsState => Boolean(s));
}

/** Сборки показанных ответов (уникальные `built_at` по порядку); больше одной — ответы смешаны. */
export function builtAts(states: MaybeState[]): string[] {
  return [...new Set(present(states).map((s) => s.built_at))];
}

/** Ответы разных сборок → сброс кэша раздела (один раз на набор сборок: если сборки так и не
 *  сошлись — плашка остаётся, повторных перезапросов по кругу нет). → смешаны ли ответы. */
export function useBuildSync(states: MaybeState[]): string[] | null {
  const qc = useQueryClient();
  const builds = builtAts(states);
  const key = builds.length > 1 ? [...builds].sort().join("|") : null;
  const done = useRef<string | null>(null);
  useEffect(() => {
    if (key === null || done.current === key) return;
    done.current = key;
    void qc.invalidateQueries({ queryKey: [WB_QUERY_ROOT] });
  }, [key, qc]);
  return key === null ? null : builds;
}
